import { market } from "../market/en";
import { invite } from "../invite/en";
import { property } from '../property/en';
import { games } from '../games/en';
import { 
  merchandiser, 
  common, 
  tableList, 
  dialog, 
  codeInfo, 
  hyy as contractHyy, 
  placeOrder, 
  codelist,
  panKou
} from "../merchandiser/en";
import { advertise} from '../advertise/en';
import {login, download} from '../login/en';
import {trading} from '../trading1/en';
import { contest } from "../contest/en";
import { taskCenter } from "../task/en";
import { ieo } from "../ieo/en";
import { earn } from "../earn/en";
import { apis } from "../api/en";
import { tradingContest } from "../tradingContest/en";
import { agent } from "../agent/en";
import { live } from "../live/en";
import { hongbao } from "../hongbao/en";

const time = {
  // r: "Days",
  // s: "Hours",
  // f: "Min",
  // m: "Sec"
  r: "D",
  s: "H",
  f: "M",
  m: "S",
};
// 状态
const state = {
  preheatIng: "Preheat",
  purchaseIng: "subscribing",
  over: "Ended",
  finish: "Completed",
  process: "In Process",
  sellout: "Sold out",
  noData: "No data",
};
// 模板文字
const text = {
  now: " Ongoing",
  start: "Starts in",
  end: "This Round Ends In",
  jd: "Progress",
  complete: "Completed",
  limited: "Time-limited Discount",

  finish: "Completed",
  subscribing: "Subscribing",
  subscribeNow: "Subscribe now",
  buyStart: "Subscription starts in",
  buyEnd: "Subscription ends in",
  projectAmount: "Project shares",
  quota: "Quota per share",
  bugPrice: "Subscription price",
  buyLimit: "Subscription limit",
  buyAmount: "Subscription amount",
  buyPos: "Subscription currency positions",
  startDate: "Start time",
  endDate: "End time",
  projectSuppot: "Project support",
  websit: "Project website",
  projectDetail: "Project introduction",
  cycle: "Subscription cycle",
  conditionTerm:
    "Within [*] days before the start time, every time the cumulative value of [**] currency recharge quantity minus withdrawal quantity reaches [***], you can subscribe for 1 copy, recharge more and get more",
  all: "All",
  step1: "Warm up",
  step2: "Subscribe",
  step3: "Lottery",
  step4: "Announce results",
  subOrder: "Subscription order",
  myOrder: "Winning order",
  proCoin: "Project currency",
  buyCoin: "Subscription currency",
  orderDate: "Order time",
  issuanceQuota: "Issuance quota",
  dealAmount: "Deal amount",
  dealPrice: "Turnover",
  status: "Status",
  ctrl: "Operate",
  checkOrder: "View lottery number",
  subNum: "Subscription number",
  myNum: "Winning lottery number",
  status0: "Subscribed",
  status1: "To deduct",
  status2: "completed",
  conditionTerm1: "* days before the subscription starts，",
  conditionTerm2: "Trading pair *",
  conditionTerm3: "All trading pairs",
  conditionTerm4:
    "Every time the cumulative value of the total transaction amount (USDT) in the Exchange Trading reaches *, you can subscribe 1 share",
  noData: "No data",
  qgsc: "Purchase and lock up",
  yhsg: "Lottery subscription",
  sgsb: "Subscription failed",

  supply: "Supply of this round",
  rate: "Exchange Rate",
  ceiling: "Ceiling",
  xmwc: "The project has been completed",
  xmze: "Total amount",
  zkjj: "Average Discounted Price",
  cyrs: "Participant Number",
  round: "[*] Round",
  r: "Participants",
  cgqg: "Successful buying",
  cgzl: "Succeeded",
  xmed: "Project supply",
  kszl: "Start Time",
  ksqg: "Start Time",
  jsqg: "End Time",
  jszl: "End Time",
  hdgz: "Purchase Rules",
  xmjs: "Project Introduction",
  tcqr: "You will be forbidden to purchase again during this round if you exit the payment confirmation. Please think again.",
  jxtc: "Exit Anyway",
  fhzf: "Return to Payment",
  qgrsd:
    "Trying to purchase... There are a lot of people purchasing the same time, please be patient. ",
  zltcqr:
    "You will be forbidden to participate again during this round if you exit the payment confirmation. Please think again.",
  zlqgrsd:
    "There are a lot of people operating the same time, please be patient.",
  wxts: "Tips: Please confirm as quickly as possible. The payment window will be closed when the payment can't be completed in [*] minutes.",
};

const seckill = {
  sgno: "Not content with subscription thresholds",
  srjymm: "Please enter trading password",
  ljzf: "To pay",
};
const apply = {
  condition: "Subscription thresholds",
  apply: "Subscribe now",
  buyPrice: "Subscription price",
  buyAmount: "Subscription amount",
  applyAmount: "Subscription amount",
  forget: "The password is wrong?",
  noAmount: "Please input Subscription amount",
  buyLimit: "Subscription limit",
  success: "Subscription succeeded！",
  paySummary:
    "Reminder: Please confirm the payment as soon as possible. If the payment is not completed within 3 minutes, the payment will be timed out and the window will be closed.",
  appFull: "Subscription amount is too large",
  seckill_async_fail_13: "The time interval is {} minutes",
};

const seckillRes = {
  seckill_async_3: "Paying... Please wait!",
  seckill_async_5: "Cancelled",
  seckill_async_fail_1: "Sorry! Please refresh and try again!",
  seckill_async_fail_2: "Sorry! Please refresh and try again!",
  seckill_async_fail_3: "Sorry! Please refresh and try again!",
  seckill_async_fail_4: "Sorry! Sold out",
  seckill_async_fail_5: "Sorry! Timeout! Please try again.",
  seckill_async_fail_6:
    "The trading password you entered is incorrect, please try again!",
  seckill_async_fail_7:
    "Trading password error has exceed limit, please try later!",
  seckill_async_fail_8: "Sorry! Timeout! Please try again.",
  seckill_async_fail_9: "Sorry! Sold out! Please wait for the next round.",
  seckill_async_fail_10:
    "There are a lot of people purchasing the same time, please try later!",
  seckill_async_fail_11: "Verification failed.",
};
const header = {
  zcgl: "Asset management",
  zczh: "Asset account",
  bbzh: "Spot Account",
  fbzh: "Buy Account",
  bdbzh: "BitLoan account",
  wdgl: "Order management",
  lswt: "Order History",
  qbhz: "Transfer",
  yhzx: "User center",
  wdhb: "Get red packets",
  openOrder: "Open Orders",
  dealStats: "Transaction summary",
  totalAsset: "Total Asset Valuation",
  tczh: "Log out",
  cz: "Contract account",
  gmcnyt: "Buy CNYT",
  yqfy: "Invitation",
  hbthhr: "HBT Partner",
  moreNew: "More",
  gfgg: "Announcements",
  zxxw: "Latest News",
  ckgd: "More",
  bbdd: "币币订单",
  bbwhydd: "币本位永续合约订单",
  etfdd: "ETF订单",
  fbdd: "法币订单",
};
const recommend = {
  vol24h: "24H Vol",
  jyd: "Pair",
  jydlx: "Type",
  zxj: "Latest Price",
  change24: "24H Change",
  line24: "72H Trend",
};
const hyy = {
  ty: "Agree",
  bkt: "No",
  wqdkt: "Confirm",

  kt12: " 1. Before you participate, be sure to thoroughly understand the basic knowledge and related risks of digital currency contract transactions and the business rules related to participating in the derivatives transactions.",
  kt13: "  2. The risks mentioned above are only enumerative, and we fail to provide a detailed list of all risk factors related to digital asset derivatives trading. Investors should also seriously consider and accept other possible risks before investing in digital asset derivatives trading.",
  kt14: "3. We sincerely hope and advise investors to make a prudent decision on whether to participate in this contract transaction and rationally allocate their digital assets based on their own actual conditions such as risk tolerance.",

  kt0: "Dear user:",
  kt1: "You have not yet opened the contract account and granted contract trading permission, please read the following terms carefully before deciding whether to open:",
  kt2: "1. When you trade in the contract market, if the market price trend is against you and cause your position margin insufficient, BiKing perpetual contract will forced-liquidate your position according to the system agreement and disclose the details.",
  kt3: "2. You must read carefully and comply with the business rules of the BiKing perpetual contract, understand the mechanism and operating principle of the contract, and understand all risks of the market.",
  kt4: "4. BiKing perpetual contract is accessing to  contract trading system. The gain and loss of the user's position changes with the fluctuation of  contract market. When there’s big losses in the position, it will wipe out in the  contract trading system. Users are requested to make their own timely trading behaviors according to the  contract market, and they are responsible for their own gains and losses. Thus, BiKing does not assume any presumption or established guarantee responsibility.",
  kt5: "5. Under certain extreme market conditions, you may find it difficult or impossible to liquidate a position. This can occure, for example, when your profit ranks first in the effective leverage PnL across the contract market, and the opponent's position is insufficient for the insurance fund to cover its loss.",
  kt6: "6. Digital asset derivative transactions may face policy regulatory risks in a certain scope of Law. Before trading, you need to make a careful judgment on the premise of understanding the policy regulatory background of the transaction region. Due to changes in relevant national and regional laws, regulations, policies, amendments to contract exchange trading rules, and the introduction of emergency measures, BiKing will disclose the statement in advance. Your pending contracts may not continue to be held, but margin and profit balances will still be settled.",
  kt7: "7. The losses caused by part or whole failure to conclude transaction when the part or whole failure is due to reasons uncontrolled by BiKing, for example, earthquake, flood, fires, and other force majere, or malfunctions of computer or communication system are undertaken at your own.",
  kt8: "8. 'Hedging' transactions, like speculative transaction, are also subject to risks arising from price fluctuations.",

  kta9: "9. If you do not have real-name authentication or are not bound to Google verification, or lend your account to someone else, it may reduce the safety of your contract margin.",

  kta10:
    "3. Under certain extreme market conditions, you may find it difficult or impossible to liquidate a position. This can occure, for example, when your profit ranks first in the effective leverage PnL across the contract market, and the opponent's position is insufficient for the insurance fund to cover its loss.",

  kt9: "I have read the Risk Warning carefully and agree to take all the risks",
  kt10: "Open contract account and grant contract trading permission",
  zjhz: "Transfer",
  ljhz: "Transfer now",
  qx: "Cancel",
  khz: "Can be transfered",
  qxz: "Choose",
  bz: "Currency",
  c: "from",
  zz: "to",
  sl: "Amount",
  qb: "All",
  ktcg: "Succeeded",
  ktsb: "Failed",
  hzcg: "Succeeded",
  hzsb: "Failed",
  wyyd: "", //未勾选已经阅读提示文案
  tc: "Sign out",
  warning1: "Please choose the currency",
  warning2: "Please enter transfer-out account",
  warning3: "Please enter transfer-in account",
  warning4: "Please enter the quantity that is less than the availale quantity",
  warning5: "Keep up to 4 decimal places",
  gb: "Close",
  openSuccess: "You confirmed Contract Trading",
  openSuccessTip: "Please transfer assets",
  wsmyz: "You have not completed real-name verification",
  hdnm: "[**]USDT non-neg chips can be obtained by completing real-name verification and adding [*]USDT",
  nmjl: "Non-neg chip record",
  nmhzjl: "Non-neg chip receive history",
  gxn: "Congratulations!",
  qwjy: "Go trading",
  yfrndhyzh: "It is been sent to your contract account",
  nzxy: "Transfer [*] USDT to the contract account to get [**] USDT non-neg chips",
  nmssm: "What is non-neg chips",
  nm: "non-neg chip",
  nxhyzh: "You pay to the contract account",
  text1: "Cumulative net transfer to contract account above [*]USDT, get",
  text2: "You only need to transfer [*]USDT to the contract account",
  text3: "You get [*]USDT mudcode",
  text4: "Balance",
  text5:
    "Cumulative net transfer to contract account above [*]USDT, and you have gotten",
  not_get_nm:
    "Sorry, non-neg chips activity has been released. non-neg chips can not be obtained in this transfer",
  yijie: "1. First-level",
  erjie: "2. second-level",
  ljjhr: "cumulative net transfer reaching",
  khd: "can get",
  hysnm: "Swap Free Chip",
  bbgg: "Swap, 100X Leverage",
  hdsj: "Activity time:",
  hdxq: "Activity details",
  ljhd: "Collect immediately",
  xdxd: "First come,first serve.",
  ylnnz: "If you win, you get it. If you lose, it's on me",
};
const Verification = {
  channel: "Verification",
  verify: "Please enter what you want to verify",
  notes: "Notes",
  notes1:
    "1. All emails, WeChat accounts, QQ accounts, domain names and community media accounts related to BiKing can be verified here. ",
  notes2:
    "2. Community media accounts (e.g. Webo, Twitter) can only be verified by account name, and needs to be case sensitive ",
  notes3:
    "3. If you have questions about the result, you can contact the customer service on the official website or APP for reconfirmation.",
  error: "Not Found",
  error1: "The account ",
  error2:
    " you entered doesn't belong to BiKing official channel. Please be cautious about your asset security, avoid any loss caused by the leaking of personal information.",
  errorNote: "Notes",
  errorNote1:
    "1. The Channel Verification now onlu supports verifying emails, WeChat, QQ, domin name and community media  ",
  errorNote2:
    "2. The chat tools, such as WeChat, can only be verified by account number(not nickname) ",
  errorNote3:
    "3. Community media accounts can only be verified by account name, and needs to be case sensitive",
  success: "It is official",
  success1: "The account:",
  success2: " you entered belongs to BiKing official ",
  success3:
    ". Please be cautious about your asset security when this account shows in other websites or channels.",
  more: "View More",
  know: "I Know",
  weChat: "WeChat",
  name: "Domin Name",
  webo: "Webo",
  twitter: "Twitter",
  email: "Email",
  contact: "Contact CS",
  bannerTip:
    "To prevent criminals from defrauding under the name of BiKing, you can use this page to verify whether the phone number, WeChat or other contacts which is used to contact you belongs to BiKing or not.",
};
const index = {
  downloadIos: 'Download for AppStore',
  downloadAndroid: 'Download for Android',
  downloadGoogle: 'Download for Google Play'
};

const NAVS = {
  xh: 'Spot',
  hhjy: 'Swap Transaction',
  ty: 'Sports',
  hqsj: 'Market Situation',
  game: 'Game',
  fx: 'Discover',
  sj: 'Data',
  fb: "OTC",
  bb: "Spot",
  jr: "Earn",
  gg: "Margin",
  jyds: "Trading Contest",
  hbhd: "Red Packet Event",
  yxhy: "Swap",
  eft: "ETF",
  flhd: "Benefits",
  flzx: "Activity",
  fast: "Basic",
  spec: "Pro",
  login: "Login",
  rig: "Sign up",
  downapp: "BiKing App",
  downappsum: "Deposit&Withdrawal, Smooth and Fast",
  zichan: "Asset",
  order: "Order",
  qbhz: "Transfer to wallet",
  lang: "Language",
  calc: "Currency",

  mb: "Buy Crypto",
  hq: "Markets",
  hy: "Futures",
  jy: "Trade",
  lc: "Finance",
  fs: "Fansup",
  xy: "Academy",
  byxy: "BiKing Academy",
  byyx: "BiKing R&S",
  coins: "COINS",
  gd: "More",
  yqhy: "Invite Friends",
  rwzx: "Mission Center",
  bbms: "USDT to purchase digital assets such as Bitcoin",
  ggms: "platform lend assets to have returns and risks magnified",
  yxms: "100 times leverage support, simple operations, many choices",
  etfms: "returns magnified, no risk of liquidation",
  pool: "Sharing Pool",
  czzn: 'Guide',
  gywm: 'About us',
  zhxx: 'Account information',
  gd:"Copy-Trading",
  yxhy: "Perpetual Futures",
  zjhy: "Bonus Futures",
  product:'product'
};

const FOOTERS = {
  zxkf: "Support",
  fawu: "Legal advice",

  us: "About Us",
  product: "Products",
  service: "Services",
  college: "Learn",

  aboutUs: "About",
  rateSum: "Fee Rate",
  notices: "News",
  helps: "Help Center",
  verific: "BiKing Verify",
  contact: "Contact Us",

  fabi: "Buy Crypto",
  bibi: "Spot",
  ganggan: "Leverage",
  swiper: "Futures",
  etf: "ETF Trading",
  licai: "Finance",

  apis: "API document",
  apisNew: "API Support",
  addCoin: "Listing Application",
  vips: "VIP Interests",
  downapp: "APP Download",
  files: "Legal Documentation",

  newuser: "Novice Camp",
  swiperSchool: "Swap Academy",
  assistant: "Learning Assistant",
  digitalintroduction: "Introduction of Digital Assets",

  watchword: "World-class Reliable Trading Platform",
  meiyitian: "Make wealth happen every day",
  chat: "Chatroom",
  shequncn: "Telegram Chinese Community",
  shequnen: "Telegram English Community",
  shequnkr: "Telegram Korean",
};

const SIDEBAR = {
  newuser: "",
  guide: "Guide",
  bbsq: "Spot Community",
  hysq: "Swap community",
  gd: "fixed",
  sq: "Put away",
};

const banner = {
  wzwh: 'Using the Biking website and/or maintaining your account indicates your agreement to our updated',
  sytk: 'Terms of Use',
  yszc: 'Privacy Policy',
  hh: 'and',
  cookie: 'Cookie Policy',
  djgb: 'Clicking “X” indicates that you acknowledge you have read and agree to the above terms and policies.',

  title: 'Diversified game and digital currency trading platform',
  marketTitle: 'Digital Currency Trading We Are Professional',
  marketSubTitle: 'Committed to providing users with more secure and stable encrypted asset derivatives trading services',
  pathTitle: 'Your Right-hand Assistant on Your Digital Currency Journey',
  pathSubTitle: 'The choice of tens of millions of users, your trustworthy platform',
  jylz: '$300 billion',
  jyl: '72 hours trading volume',
  sxs: 'Cryptocurrencies are live',
  zcyh: 'Registered user',
  zdjy: 'Minimum transaction fee',
  connectTitle: 'Why choose us',
  connectSubTitle: 'BiKing helps you create, add value and preserve wealth',
  advantageText1: 'Top Performance·Extremely Fast Transactions',
  advantageSubText1: 'Driven by London Stock Exchange technology, ultra-low latency, extremely fast matching',
  advantageText2: 'Asset Protection Extreme Security',
  advantageSubText2: 'Biking complies with CCSS standards to ensure asset and data security',
  advantageText3: 'High liquidity · Low spread',
  advantageSubText3: 'Biking contract leveraged trading, ultra-high efficiency, minimum slippage',
  advantageText4: '24/7 service',
  advantageSubText4: 'Ensure the normal operation of the system and provide 24/7 customer service',
  advantageText5: 'Easy to use',
  advantageSubText5: 'Provide a variety of order systems and trading tools, with controllable risks',
  advantageText6: 'Anytime, anywhere · Trade with peace of mind',
  advantageSubText6: 'Biking platform provides web version, mobile app, API and FIX connection',
  netWorkTitle: 'The common choice of 1.2 million users in 26 countries',
  netWorkSubTitle: 'Committed to providing users with more secure and stable encrypted asset derivatives trading services',
  smxz: 'Scan code to download',
  fxbzj: 'risk margin',
  fkbz: 'Let every transaction have a full range of financial risk control protection',
  question1: '1. Introduction to BiKing Exchange',
  questionContent1: 'BiKing Exchange is a world-leading digital asset trading platform in Singapore, holding US/Canada MSB dual licenses, providing services such as trading, storage, and management of various digital assets.',
  question2: '2. What products does BiKing Exchange provide?',
  questionContent2: 'BiKing Exchange provides the following products: Perpetual Futures - excellent depth, instant matching; spot trading - 0 procedures, fast transactions; documentary community - senior traders, stable strategy orders; bonus trading - unique Model, continuous benefits; Web wallet - decentralized one-stop service',
  question3: '3. How to register BiKing Exchange?',
  questionContent3: 'You can register on the official website of BiKing Exchange or the BiKing APP. Click Register and complete the registration process to use BiKing Exchange for digital currency investment and wealth management.',
  question4: '4.How to buy digital currency through BiKing Exchange?',
  questionContent4: 'BiKing Exchange supports multiple payment methods and multiple fiat currencies, providing more choices and convenience for global users. No matter which country or region the user is from, they can easily use the currency to purchase digital currency',
  question5: '5.How to trade digital assets?',
  questionContent5: 'You can choose the digital asset you want to trade on BiKing Exchange, enter the trading page, choose to buy or sell, enter the transaction amount and price, and confirm the transaction. And BiKing Exchange supports a variety of digital asset transactions, including Bitcoin, Ethereum, Litecoin, Ripple, etc.',
  question6: '6.How does Biking Exchange guarantee the security of user assets?',
  questionContent6: 'BiKing Exchange adopts multi-layer encryption technology to ensure the security of user information and assets, and adopts a storage method that separates hot and cold wallets to ensure the security of user assets.',


  investor: '300W cryptocurrency investors trust',
  transaction: 'Invest, trade and grow in BIKing',
  hypt: 'The global security leading digital asset contract trading platform',
  yjpc: 'One click to open the position',
  jscrj: 'Fast deposit and withdrawal, 60S open transaction and realize zero sliding point transaction',
  zcpt: 'Receive USDT upon registration',
  email: 'Email address',
  phone: 'Mobile number',
  zc: 'Register',
  yhjaqbz: 'Bank-level security',
  lhdmch: '0 slippage second matching',
  qthkf: '7*24 hours customer service',
  rmjmhb: 'Popular cryptocurrencies',
  jrsq: 'Join the Biking Community',
  hqzxhd: 'Get the latest Biking event information and online support',
}

const navCard = {
  join: 'Join BiKing',
  hzdl: 'BiKing BiKing cooperation agent signing is looking forward to your joining',
  jmrx: 'Agent joining hotline: 183,283,232,998',
  contract: 'Contract online',
  yxhy: 'Quick contract currency king double contract surprise launch',
  jylh: 'The transaction is more flexible and the income is more abundant',
  usa: 'USA AND CANADA MSB',
  zmjys: 'BIKing, a well-known overseas exchange, won the multi country compliance photo',
  fxpf: 'Risk means payment is safe and reliable',
  srhy: '30% real gold will be given to the first person of coins',
  hdsj: 'Activity time: 0:00, November 1, 2022 to 0:00, December 1, 2022'
}

const choice = {
  gjyh: 'Common choice of 1.2 million users in 26 countries',
  jyfu: 'Committed to providing users with more secure and stable crypto asset derivatives trading services',
  wsmxzwm: 'Why choose us',
  jsty: 'Fast experience',
  jmsj: 'The transaction interface design combines many years of user operation experience of the platform, with clear process, convenient operation, and microsecond core memory matching technology to provide users with a more convenient and comfortable transaction experience.',
  kfx: 'Risk resistant price mechanism',
  pthybz: 'The price of the currency of the platform contract adopts the integrated algorithm of multi-source indexes, which has strong risk control ability and effectively avoids user risks and losses caused by market fluctuations in various extreme markets.',
  zjaqbz: 'Fund security guarantee',
  zjdt: "All fund dynamics are completed with multiple offline signatures to ensure microsecond level judgment, deep cold storage of assets, comprehensive escort of users' fund security, and 100% bank level security risk control for each user.",
  jszc: 'Top level technical support',
  ptjstd: 'The platform technology team is composed of a group of top blockchain technology experts to ensure the ultimate experience of users and provide strong technical support for the development and operation of the platform.',
  jcjz: 'Stepped position reduction mechanism',
  hqbh: "According to the changes in market conditions, reasonably trigger the user transaction risk control mechanism to protect the user's property 24 hours a day.",
  kf: '24-hour customer service',
  ptkf: "The platform adopts a 24-hour customer service shift system and takes every user's problems seriously."
  
}

const plat = {
  ptgn: 'Platform function',
  zjms: 'Gift mode',
  zjjs: 'The bonus model is a new play method of featured contracts launched by the BiKing team for contract users across the network. The operation process of the bonus model is consistent with that of the firm offer contract. The profit obtained from opening positions can be transferred to the contract account to continue opening positions or directly withdraw cash. The ways to obtain the bonus include: real-time return of the renewal fees, air drop activities, task completion, etc.',
  zcms: 'Full warehouse mode',
  zcjs: 'In the full warehouse mode, the margin and floating profit and loss of all positions are interconnected, and all account assets, including opening margin, are used as floating margins. Under the full warehouse mode, it has strong risk control ability, but also when the market fluctuates violently, it is easy to exceed the loss expectation. ',
  zucms: 'Warehouse by warehouse mode',
  zucjs: 'In the warehouse by warehouse mode, each order is independent of each other, and the profit and loss are calculated independently according to the opening price of each position. After the loss of the principal (or called margin) of a single order reaches the maximum stop loss point, it will be forced to close the position. When the profit reaches the maximum profit limit, the position will be closed automatically. When there is a position order or plan in the warehouse by warehouse mode, the warehouse opening mode cannot be switched. ',
  gdgn: 'Documentary function',
  gdjs: 'After the documentary function is started, all the opening and closing positions of the documentary traders will be synchronized, and synchronization cannot be completed only when the account balance is insufficient or exceeds the upper limit of positions. If there is no manual cancellation of the documentary function, the documentary function will continue to open. ',
  bfpc: 'Partial closing',
  bfjs: 'When holding a certain number of multiple positions or short positions, you can freely choose the closing amount according to the market changes and profit and loss situation. At the same time, the profit and loss amount of the position sheet will also be settled in equal proportion according to the proportion of the closing amount to the total amount of margin. The floating profit will remain unchanged after closing.',
  fxkc: 'Reverse opening',
  fxjs: 'The system will automatically help you to balance the currently selected holding position at the best market price, and open the position with the same number of positions in the opposite direction at the best market price, to avoid missing the reversal of the market or the situation that it is too late to open the position when the reversal of the market comes. ',
  zjbzj: 'Additional margin',
  zjbzjjs: 'When holding a certain number of multiple positions or short positions, margin can be added under the premise of various parameters of the current position. After adding positions, the position coefficient will be calculated according to the respective position parameters when opening positions and adding margins.'
    
}

const risk = {
  fxbzj: 'Risk margin', 
  fxbz: 'Let every transaction have a comprehensive fund risk control guarantee'
}

const license = {
  license: 'Biking won the MSB financial license',
  hgyy: 'Compliance operation and global layout',
  login: 'login',
  download: 'Scan the code to download the BiKing',
  support: 'Support',
  jsjy: 'Deal quickly at any time',
  ljxz: 'Download BiKing App now'
}

const footer = {
  yhyh: 'The most user-friendly',
  jypt: 'Contract trading platform',
  yhzc: 'User Support',
  flsm: 'Rate Description',
  ggzx: 'Announcement Center',
  yhxz: 'Notice to users',
  tksm: 'Term Description',
  fxzs: 'Risk Reminder',
  xylb: 'Protocol List',
  gywm: 'About us',
  gy: 'About',
  lxwm: 'Contact us',
  appxz: 'App Download',
  callus: 'Subscribe to BIKING',
  zwzxxx: 'Get the latest news, insights and price fluctuations',
  zc: 'Register',
  email: 'Email',
  callingus: 'Contact us',
  bqsy: 'Copyright',
  tips: 'Warm tip: investment is risky, and you need to be cautious when entering the market'
}

const card = {
  title: 'Why we are the most friendly contract platform',
  text: 'BiKing helps you create, add value and preserve wealth',
  djxn: 'Return the service charge',
  jsqd: '100% real time return of service charges greatly reduces the cost of order making and improves profit opportunities',
  zcbz: 'Fast deposit and withdrawal',
  cssbz: "Fast deposit and withdrawal, smooth deposit and withdrawal, ensuring the safety of users' funds, and not missing every order making market",
  gld: 'Easy to use',
  zxhd: 'It only takes 10 seconds to complete the registration and open the warehouse. The unique security risk control system protects user privacy, and the registration process is simpler',
  qthfw: '24/7 service',
  kffw: 'Comfortable and smooth interactive experience, 24-hour online customer service of gold standard margin mechanism, real-time answer to trading questions',
  bjyy: 'Easy to use',
  fxkk: 'Provide a variety of order systems and transaction tools, with controllable risks',
  axjy: 'Anytime, anywhere, secure trading',
  bkms: 'BiKing platform provides web version, mobile application, API and FIX connection'
}

const news = {
  title: 'News & Vision',
  text: "Learn about the news and business characteristics of the world's top cryptocurrency exchanges",
  sy: 'Field of view',
  ltitle: 'Bitcoin can solve the unique challenges of emerging markets',
  ldesc: 'This article is equivalent to Cointelgraph at first As the Blockchain Economy Istanbul Summit focuses on the development of emerging markets, the popularity of Bitcoin continues to be driven by the needs of individual cases',
  more: 'Learn more',
  xwfbs1: 'Press room',
  rdesc1: 'Istanbul Summit on Blockchain Economy in BiKong Sponsored Area of Digital Asset Exchange 2022',
  xwfbs2: 'Press room',
  rdesc2: 'Istanbul Summit on Blockchain Economy in BiKong Sponsored Area of Digital Asset Exchange 2022',
}

const info = {
  hzhb: 'Partner of automated trading platform',
  qsjy: 'Use the trading robot to easily trade in BiKing',
  quadency: 'QUADENCY',
  clpt: 'Professional automatic trading strategy platform',
  stacked: 'Stacked',
  glcf: 'Users can use Stacked to invest in encryption index. Automate transactions and manage wealth '
}
const menu = {
  creditCardOrder: 'Pay order',
  ptmb: 'C2C',
  kjmb: 'Buy Crypto',
  xykmb: 'Credit card to buy Crypto',
  order: 'Order',
  userOrder: 'user order',
  merchantOrder: 'merchant order',
  quickOrder: 'quick order',
  merchant:'Merchant',
  asMerchant:'become a merchant',
  advertisingManage: 'advertising management',
  financialStatements: 'financial statements',
  messageCenter: 'Notification',
  more: 'More',
  paymentSettings: 'payment settings',
  publish: 'place an ad',
  overview: 'Overview',
  aqzx: 'Security',
  phsz: 'Preference Settings',
  hykhj: 'Contract carnival season, a new era of trading',
  xszn: "Beginner's Guide",
  bwyjy: 'BiKing Research Institute',
  bwsq: 'BiKing Community',
  yhxz: 'User information',
  bwysp: 'BiKing Derivatives',
  jyxz: 'OTC trading instructions'
}

const otc = {
  Realtimequotes:'Real-time quotes are for reference only. Please refer to the prices on the third-party service provider s website for accuracy.',
  Realtimequotes1:'Transaction Limit',
  Realtimequotes2:'Reference Price  （{price}）',
  Realtimequotes3:'Purchase',
  Realtimequotes5:'Please enter the purchase amount',
  Realtimequotes6:'Maximum',
  Realtimequotes7:'Exceeds Maximum Limit',
  Realtimequotes8:'Quantity',
  Realtimequotes9:'Handling Fees',
  Realtimequotes10:'Payment Method',
  Realtimequotes11:'Delivery Time',
  Realtimequotes12:'10-20 minutes after successful payment',
  Realtimequotes13:'Confirm your purchase',
  Realtimequotes14:'Purchase Steps',
  Realtimequotes15:'Select the digital currency you want to purchase, the fiat currency you want to pay in, and the service provider you want to use.',
  Realtimequotes16:'Enter the purchase amount, fill in your information on the third-party service provider s website, and complete payment.',
  Realtimequotes17:'View the purchased digital currency in your BiKing asset top-up history and view the order details on the service provider s website.',
  Realtimequotes18:'You will be redirected to {XXXXX} to make your purchase.',
  Realtimequotes24:'Warm Reminder',
  Realtimequotes19:'{XXXXX} is an independently operated third-party fiat currency and cryptocurrency trading platform. All related services are provided by {XXXXX}.',
  Realtimequotes20:'The reference price includes platform fees. The actual transaction price is based on the price on {XXXXX} s official website.',
  Realtimequotes21:'BiKing assumes no responsibility for any losses or damages incurred as a result of using this service.',
  Realtimequotes22:'Apparently, proceed now.',
  Realtimequotes23:'Purchase amount',
  Realtimequotes25:'Third-party transactions',
    Realtimequotes26:'Please complete your email address first',
      Realtimequotes27:'Complete now',
       Realtimequotes28:'Third-party merchant name',
  bjgq: 'The quote has expired, please retrieve it again',
  gxbj: 'Update quote',
  zxkdh: 'Minimum exchangeable {min} {symbol}',
  zdkdh: 'Maximum exchangeable {max} {symbol}',
  Available: 'Available',
  Unknown: 'Unknown',
  qxgz: 'Cancellation policy: If the buyer accumulates 200 cancellations in a single day, purchasing functionality will be restricted for that day.',
  xncs: 'Sell to you',
  meBuy: 'I want to buy',
  服务商: 'Service Provider',
  qxzzffs: 'Please select payment method',
  qdqx: 'Confirm cancel',
  wzxx: "I'll think again",
  msk: 'Buyer payment method',
  zhmc: 'Account name',
  zhxq: 'Account details',
  xzhb: 'Select currency',
  
  buyer: 'buyer',
  seller: 'seller',
  goSet: 'to add',
  addPayWayTitle: 'Add payment method',
  addPayWay: 'You need to add or activate at least one payment method before {type} digital currency',
  supportPayWay: 'You need to add and enable the payment method supported by {type}',
  top: 'top',
  marginTips: 'You have paid {baseMarginPaid} USDT deposit, and you need to pay no less than {needMargin} USDT',
  eyqx: 'Canceling the appeal 3 times a day will limit the appeal. At the same time, if the cancellation is malicious, the account will be frozen after verification. Please operate with caution!',
  qdbzgm: "Are you sure you don't want to buy anymore?",
  qxbtk: 'There will be no refunds after canceling the order, if you have already paid, please do not cancel the order.',
  yzjbzj: 'Ordinary merchants have added margin',
  xbjjcbzj: 'Need to pay the basic security deposit',
  jg: 'Price',
  zxjgxd: 'Place an order at the latest current price',
  je: 'Value',

  ccxe: 'limit exceeded',
  yebz: 'Insufficient balance',
  qxsm: 'Please use your real name first',

  dfb: 'to be released',
  jywc: 'transaction complete',
  buy: 'Buy',
  sell: 'Sell',
  coin: '',
  allCoin: 'All currencies',
  frenchCurrency: '',
  payWay: 'PayWay',
  all: 'All',
  bankCard: 'Bank card',
  zfb: 'Pay with Ali-Pay',
  wx: 'WeChat payment',
  search: 'Inquire',
  merchant: 'Merchants',
  turnover: 'Turnover',
  completionRate: '%completion rate',
  quotaOrNumber:'Quantity',
  number: 'Quantity',
  quota: 'Quota',
  price: 'Unit Price',
  paymentMethod: 'Payment Method',
  trade: 'Trade',
  handlingFee: '0 handling fee',
  buyUsdt: 'Buy USDT',
  sellBtc: 'Sell USDT',
  theRemainingAmount: 'The remaining amount',
  userRealName: 'User real name',
  businessMessage: 'Business message',
  wantPay: 'I want to pay',
  wantSell: 'I want to sell',
  receive: 'I will receive',
  password: 'Password',
  pleaseEnterPassword: 'Please enter password',
  cancel: 'Cancel',
  buyUSDT: 'Buy USDT',
  sellUSDT: 'Sell USDT',
  Paymentchannel :'Payment channel (please refer to the service provider’s exchange rate.)',
  lumpSum: 'lump sum',
  agree: 'If you agree to conduct C2C transactions with BiKing, it means you accept',
  mzsm: 'Legal Disclaimer of BiKing C2C Trading',
  quit: 'Quit',
  confirm: 'Sure',
  orderDetail: 'Order details',
  limitExceeded: 'Limit exceeded',
  quantityRemaining: 'Insufficient quantity remaining',
  cryptoTitle: 'Buy USDT easily in just a few steps',
  cryptoSubTitle: "The world's leading secure digital asset contract trading platform",
  availableBalance: 'Available balance',
  sellAll: 'Sell all',
  fundsTransfer: 'Funds transfer',
  threeStep: 'Only three steps to buy Crypto',
  advantage: 'Advantages of choosing BiKing to buy and sell cryptocurrencies',
  commonQuestion: 'Q&A',
  otc_title: 'Buy/sell cryptocurrencies using C2C 0 fee',
  otc_title1: "Conduct zero-fee transactions safely and easily on BiKing. Instantly trade USDT' through bank transfer, credit card and other payment methods,",
  commonQuestion1: 'What is cryptocurrency C2C trading?',
  commonQuestion2: 'What are the costs of C2C transactions?',
  commonQuestion3: 'What are merchants on BiKing C2C?',
  commonQuestion4: 'Can BiKing C2C merchants make a profit?',
  commonQuestion5: 'How to avoid C2C fraud?',
  commonQuestion1_desc: "Cryptocurrency C2C refers to peer-to-peer cryptocurrency transactions where users can directly exchange cryptocurrencies with each other without the need for intermediaries like centralized exchanges.",
  commonQuestion2_desc: "The costs of C2C transactions may vary significantly based on the platform, specific cryptocurrencies involved, and network congestion during the transaction. However, BiKing C2C charges zero fees for cryptocurrency transactions, eliminating the need for intermediaries.",
  commonQuestion3_desc: "Merchants on BiKing C2C are verified users who can post trade advertisements on the platform and engage in transactions with other users.",
  commonQuestion4_desc: "The profitability of BiKing C2C merchants depends on various factors, including their trading strategies, transaction frequency, bid-ask spreads, and overall market conditions.",
  commonQuestion5_desc: "To prevent C2C fraud, it is advisable to verify the counterparty's identity, use secure platforms, limit the sharing of personal or financial data, and utilize traceable payment methods.",
  register: 'Register',
  registerByPhone: 'Email or Phone registration',
  authentication: 'Authentication',
  authenticationId: 'To complete the identity verification, only ID documents are required',
  buyCoins: 'buy coins',
  buyCoinsByCard: 'credit/debit card or bank transfer to buy coins',
  fast: 'Fast and convenient',
  easyUse: 'easy to buy coins',
  fastPayment: 'It only takes a few minutes to get to the account quickly.',
  multiplePayment: 'Multiple payment methods',
  platformSupports:'the platform supports multiple payment methods',
  flexibleConvenient: 'It provides users with greater flexibility and convenience.',
  safeReliable: 'Safe and reliable',
  measure: 'adopt multiple security technologies and measures',
  informationSecurity: 'ensure the safety of funds and user information.',
  questionTitle1: '1. Introduction to BiKing Exchange',
  questionSubTitle1: 'BiKing Exchange is a world-leading digital asset trading platform in Singapore, holding US/Canada MSB dual licenses, providing trading, storage, management and other services for a variety of digital assets.',
  questionTitle2: '2. What products does BiKing Exchange provide?',
  questionSubTitle2: 'BiKing Exchange provides the following products: Perpetual Futures - excellent depth, instant matching; spot trading - 0 procedures, fast transactions; documentary community - senior traders, stable strategy orders; bonus trading - unique Model, continuous benefits; Web wallet - decentralized one-stop service',
  questionTitle3: '3. How to register BiKing Exchange?',
  questionSubTitle3: 'You can register on the official website of BiKing Exchange or the BiKing APP. Click Register and complete the registration process to use BiKing Exchange for digital currency investment and wealth management.',
  questionTitle4: '4. How to buy digital currency through BiKing Exchange?',
  questionSubTitle4: 'BiKing Exchange supports multiple payment methods and multiple fiat currencies, providing more choices and convenience for global users. No matter which country or region the user is from, they can easily use the currency to purchase digital currency.',
  questionTitle5: '5. How to trade digital assets?',
  questionSubTitle5: 'You can choose the digital asset you want to trade on BiKing Exchange, enter the trading page, choose to buy or sell, enter the transaction amount and price, and confirm the transaction. And BiKing Exchange supports a variety of digital asset transactions, including Bitcoin, Ethereum, Litecoin, Ripple, etc.',
  questionTitle6: '6. How does BiKing Exchange guarantee the security of user assets?',
  questionSubTitle6: 'BiKing Exchange adopts multi-layer encryption technology to ensure the security of user information and assets, and adopts a separate storage method for hot and cold wallets to ensure the security of user assets.',
  
  orderType: 'order type',
  orderStatus: 'order status',
  to: 'to',
  startTime: 'start date',
  endTime: 'end date',
  orderNo: 'order number',
  status: 'state',
  totalPrice: 'total price',
  numberOrFee: 'transaction quantity/handling fee',
  tradingPartners: 'trading partners',
  time: 'time',
  operate: 'operate',
  details: 'details',
  noPay: 'pending payment',
  payed: 'already paid',
  finish: 'completed',
  canceled: 'cancelled',
  complaint: 'complaint',
  legalCurrency: 'amount of legal currency',
  virtualCurrency: 'digital currency',
  virtualCurrencyAddress: 'Payment address',
  paymenttype: 'Payment type',
  creatTime: 'creation time',
  success: 'success',
  pending: 'processing',
  awaiting: 'to be confirmed',
  declined: 'fail',
  deposittokens:'Sell order waiting for user to deposit tokens',
  makepayment:'Buy order waiting for user to make payment',
  verification:'Pending user identity verification',
  Transactioncancelled:'Transaction cancelled',
  Transactionrejected:'Transaction rejected',
  mjskfs: 'Seller payment method',
  mjfkfs: 'Buyer payment method',
  toPay: 'to pay',
  ddzdqx: 'If you have not selected a payment method within {payTime}, the order will be automatically canceled',
  paying: 'The other party is paying...',
  fkckh: 'Payment Reference Number:',
  dfwfkqx: 'If the other party has not paid within {payTime}, the order will be automatically canceled',
  ddqxwfck: 'Order has been cancelled, payment information cannot be viewed',
  ddqxckh: 'Order has been cancelled, payment reference number:',
  ssz: 'Appealing, please wait, payment reference number:',
  qxss: 'cancel appeal',
  xzfkfs: 'The payment method you choose',
  ddywc: 'order completed',
  ss: 'appeal',
  wcfqss: '* Complaints can only be initiated 1 minute after the order is completed',
  bnfqss: '* Complaints will no longer be possible after {time} hours have passed',
  zxkf: '* After OTC purchase, you need to wait T+1 to withdraw cash. If in doubt, please consult customer service.',
  sjyjn: 'Merchant has paid {deposit} {depositName} security deposit',
  wen1: '1. When can I receive the payment?',
  da1: 'You will be notified when the other party completes the payment.',
  wen2: '2. The buyer has not paid after placing the order, how to deal with it?',
  da2: 'The seller cannot cancel the order, but if the waiting time is too long, you can file a complaint and the customer service team will resolve it for you.',
  wen3: '3. What will be the impact of not releasing digital assets in time?',
  da3: 'After receiving the payment, if you fail to confirm the receipt in time, it may cause the buyer to file a complaint and affect your reputation on the platform; at the same time, your assets will remain frozen in your platform wallet until processed.',
  wen4: '4. Precautions for payment collection',
  da4: `1) Please double-check whether you have actually received the money from the other party. Don’t believe in any reason to urge the release of coins. After confirming the payment, click "Confirm Receipt" to avoid loss of digital assets! <br/>2) When the real name of the buyer's transfer bank account is inconsistent with that of the platform account, please pay attention to the risk of collection. If you have any doubts, please appeal in time.`,
  qzgdsjnzf: 'To be paid, please pay {totalAmounts} {fiatCurrency} to {associatedAdMerchantNickname} within {payTime}, payment reference number:',
  nxdfgm: 'You bought {amount_s} {coinsName} from {associatedAdMerchantNickname} ({realName})',
  dfxngm: '{userNickName} ({realName}) buys {amount_s} {coinsName} from you',
  nxdfcs: 'You sold {amount_s} {coinsName} to {associatedAdMerchantNickname} ({realName})',
  dfxncs: '{userNickName} (${realName}) is selling you {amount_s} {coinsName}',
  payed: 'Paid',
  dddffx: 'Waiting for the other party to let go...',
  njhdq: 'You will get {quantity}{coinsName}',
  qxdd: 'cancel order',
  kfqss: 'More than {complaintPayed} minutes after payment, if the other party has not released the coins, you can initiate a complaint',
  yfkfkckh: 'The other party has paid, payment reference number:',
  qjkqrsk: 'Please confirm payment as soon as possible',
  ddnsk: 'waiting for your payment',
  zfje: 'payment amount',
  skzh: 'Receiving account number:',
  fkzhxm: 'Payment account name:',
  qdskh: '* Please make sure to confirm after receiving the payment in your own payment tool',
  fbl: 'release coins',
  dfyqrfk: '* The other party has confirmed the payment, if the payment is still not received after {complaintPayed} minutes, a complaint can be initiated',
  jkcssk: '* After the other party confirms the payment for more than 24 hours, we will not be able to initiate an appeal, please verify the payment as soon as possible',
  qrfb: 'Confirm release',
  qwbqr: 'Please be sure to confirm that you have received the payment for the current order and confirm that the amount is correct before releasing the coins',
  wyqrskzq: 'I confirm payment has been received and is in the correct amount',
  tjssyy: 'Please submit reason for appeal',
  srssyy: 'Please enter the reason for appeal',
  sctpxt: 'Upload picture (optional)',
  upload: 'upload',
  zdscsz: '* Up to three pictures can be uploaded, and jpeg, jpg, png formats are supported, please ensure that they are less than 3Mb',
  sstj: 'submit',
  qrfk: 'Confirmation of Payment',
  fkje: 'Payment Amount',
  sdzz: '*The platform does not support automatic deduction. Please transfer the amount to the above account from your own account. After the transfer is completed, please be sure to click on payment. If the payment button is not clicked after the transfer, any resulting losses will be borne by you.',
  bzts: '*Please do not include information such as BTC, USDT, or BiKing in the remarks when transferring, otherwise the seller may refuse.',
  wfk: 'Unpaid',
  w: 'I',
  srxxfs: 'Enter information, press Enter to send',
  "dan": 'single',
  bnch: 'Cannot add the same type of payment method',
  sd:'Swap',
 from:'Pay',
 to:'Get',
 rate:'Exchange ratio',
 fees:'Fee',
 successful:'Swap successful',
 slippage:'Slippage',
 standards:'Fee charging standard',
 transactionamount:'{num} of transaction amount',
 confirm:'Confirm exchange',
 records:'All flash exchange records',
 chaeckrecords:'View all flash exchange records》',
 tocurrency:'Consumption currency',
 consumption:'Consumption quantity',
 Getcurrency:'Get currency',
 GetQuantity:'Get quantity',
 ExchangeStatus:'Exchange status',
 Exchangetime:'Exchange time',
 Youwillconsume:'You will consume',
 YouwillGET:'You will get',
 Consumption:'Consumption channels',
  Converted:'Converted {aaa} to {bbb} successful',
  recommend:'recommend',
  merchantname:'Third-party merchant name',
  Apparently:'Apparently, proceed now.',
  usingthisservice:'BiKing assumes no responsibility for any loss or damage incurred as a result of using this service.',
  wcsj: "Completion Time"
}
const otcMerchant = {
  bzj: 'Margin',
  mmggs: 'Number of buy and sell advertisements',
  bx: 'Unlimited',
  ggzed: 'Total advertisement amount',
  kzjgged: 'Additional advertisement amount',
  zjbzjbs: 'Additional margin multiple',
  tbzss: 'Synchronous display of 10 items',
  tjsjsqb: 'Submit Business Application Form',
  wcgjkycrz: 'Complete Advanced KYC Verification',
  ynlx: 'After reviewing the form, an OTC specialist will contact you promptly',

  zbzl: 'prepare materials',
  kssh: 'quick review',

  h1: 'Intelligent transaction',
  h2: 'Become a C2C transaction expert',
  h3: 'Soon to be a certified merchant',
  sjqy: 'Merchant rights',
  c2cjy: 'In addition to C2C transaction <span>0 fee rate</span>, we also provide merchants with more colorful rights and interests',
  fbq: 'your fiat zone',
  ptsj: 'Ordinary business',
  xsqy: 'Become a certified merchant and enjoy more benefits',
  wtd: 'Once the application is successful, the order can be issued',
  xjn: 'A {deposit} security deposit is required',
  ljsq: 'apply immediately',
  cwptsj: 'You have become an ordinary merchant',
  cwrzsj: 'You have become a certified merchant',
  rzsj: 'Certified Merchant',
  xrd: 'Enjoy the highest degree of trust in the trading market',
  nbyq: 'Biking internal invitation only',
  rzbs: 'A more distinguished business certification logo',
  pmq: 'get priority ranking',
  kffw: 'Enjoy 1 to 1 customer service',
  sjxy: 'OTC {level} Agreement',
  xsjc: 'Beginner Tutorial',
  jygz: 'Trading Rules',
  close: 'closure',
  submited: 'I have submitted',
  submitSuccess: 'Submitted successfully',

  sqsj: 'Apply to be a merchant',
  fwxy: 'Biking.com Merchant Service Agreement',
  xyb: 'BiKing.com is a platform for users to trade digital assets and provide related services. For the convenience of expressing this agreement, the company and this website collectively use "we" or other first-person titles in this agreement. As long as the natural person or other subject who registers and logs in to the website is a user of this website, for the convenience of expressing this agreement, "you" or other second person will be used below. For the convenience of this agreement, we and you are collectively referred to as "the parties" in this agreement, and we or you are individually referred to as a "party".',
  ptsm: 'Platform statement:',
  p1: '1. This website is only used as a place to provide digital asset transaction information, consultation and transaction on digital asset transactions. This website does not participate in any substantial digital asset transactions. Therefore, both parties to the transaction should carefully determine the relevant digital assets and/or information. The authenticity, legitimacy and validity of the website, and bear the responsibility and loss arising therefrom.',
  p2: '2. Any opinions, news, discussions, analysis, prices, suggestions and other information on this website are general market comments and do not constitute investment advice. We are not responsible for any direct or indirect losses arising from reliance on this information, including but not limited to any loss of profits.',
  p3: '3. The content of this website will be changed at any time without further notice. We have taken reasonable measures to ensure the accuracy of the information on the website, but we cannot guarantee its accuracy, and we will not be responsible for any information on this website or failure to Losses arising directly or indirectly from delays or failures in linking to the Internet, sending or receiving any notifications and information.',
  p4: '4. There are also risks in the use of Internet-based trading systems, including but not limited to software, hardware, and Internet link failures. Since we have no control over the reliability and availability of the Internet, we cannot be held responsible for distortions, delays and link failures.',
  p5: '5. It is forbidden to use this website to engage in all illegal transactions or illegal activities such as money laundering, smuggling, commercial bribery, etc. If any suspected illegal transactions or illegal activities are found, this website will take various available means, including but not limited to freezing accounts, Notify the relevant authority, etc., we do not assume all the responsibilities arising therefrom and reserve the right to pursue the responsibility of the relevant person.',
  p6: '6. It is forbidden to use this website to conduct malicious manipulation of the market, improper transactions and other unethical trading activities. If such incidents are found, this website will warn and restrict transactions for all unethical behaviors such as malicious price manipulation and malicious influence on the trading system. For preventive protection measures such as closing accounts and closing accounts, we do not assume all responsibilities arising therefrom and reserve the right to pursue responsibilities against relevant persons.',
  p7: 'When you agree to the BiKing Service Agreement, you are deemed to have agreed to the entire content of the platform statement. This agreement is concluded jointly by you and the operator of BiKing.com, and this agreement has complete contractual effect.',
  zcbzj: 'Article 1: Asset Margin',
  p8: '1. After the merchant passes the KYC and anti-money laundering review of the platform, the platform will require the merchant to deposit a certain deposit in its platform account to ensure the safety and smoothness of its transactions on the platform.',
  p9: '2. The specific amount of the deposit will be displayed in the legal currency assets of the merchants on this platform, and will also be displayed to users during the transaction process.',
  p10: '3. In the event of any of the following situations, the platform has the right to seize and dispose of the merchant’s security deposit, and the security deposit will be detained for ≥ 1 month. If it is determined that the platform and users have suffered losses, the security deposit will be deducted in proportion.',
  p11: '1) The merchant has a dispute during the transaction, and the merchant is judged to be responsible and perform the corresponding obligations, but the merchant refuses to cooperate;',
  p12: '2) Merchants conduct transactions with unrealized accounts on this platform;',
  p13: '3) Merchants use this platform to engage in any illegal activities;',
  p14: '4) The merchant violates this agreement or any legal documents or transaction rules on this website;',
  p15: '5) Merchants are suspected of leading users to trade on other platforms;',
  p16: '6) Merchants are suspected of leading users to falsely register to defraud new users of the platform for promotion rewards;',
  p17: "7) The merchant is suspected of admonishing the users of the platform's partners to switch to other platforms for transactions.",
  cxzg: 'Article 2: Revocation of merchant qualification',
  p18: 'In the event of the following circumstances, the platform has the right to unilaterally disqualify you as a merchant:',
  p19: '1. Complaints by users of this platform for many times during the transaction;',
  p20: '2. There is any false information in the submitted application materials;',
  p21: '3. Fraud or other dishonest behavior occurs in the transaction;',
  p22: '4. Do not cooperate with the customer service of this platform to process the order or deliberately delay the customer service to process the order;',
  p23: '5. Maliciously exploiting the rules of this platform for profit;',
  p24: '6. Violation of laws and regulations, this agreement, or the legal documents or transaction rules of this website;',
  p25: '7. Behaviors identified by this platform as inconsistent with public order, good customs and fair trade;',
  p26: '8. Other violations of laws and regulations.',
  zlbh: 'Article 3: Business Data Protection',
  p27: '1. Management of merchant information: The authentication information (including the previous real-name authentication materials) submitted to this website when you apply to become a merchant will be irrevocably authorized to be retained by this website. This website promises not to disclose, edit or disclose your certification information except for statutory or agreed reasons, and not to use the non-public content stored on this website for commercial purposes, except for the following circumstances: You authorize this website to disclose relevant information;',
  p28: '2. This website is provided to national judicial and administrative agencies;',
  p29: '3. This website is provided to affiliated companies of this website;',
  p30: '4. When a third party provides services to users together with this website, the third party will provide you with the relevant information required for the service;',
  p31: '5. Based on the need to resolve civil disputes between you and a third party, this website has the right to provide your identity information to the third party.',
  sjcn: 'Article 4: Merchant Commitment',
  p32: '1. Accepting all the terms of this agreement is a prerequisite for your application for certification.',
  p33: '2. You represent and warrant that you shall not apply for certification for any purpose that is illegal or prohibited by this agreement.',
  p34: "3. You may not use the application service in any manner that may damage, paralyze, overload or impair other websites or other websites' services or this website, or interfere with other people's use of the merchant application.",
  p35: '4. You may not obtain or attempt to obtain any materials or information in any way without the permission of this website.',
  p36: '5. You confirm and promise: your use of this website for transactions is not for the purpose of violating laws and regulations or disrupting the order of digital asset transactions on this website.',
  p37: '6. The merchant promises to abide by all information disclosure requirements of the platform for digital asset transactions, and truthfully provide documents, materials or information in accordance with the requirements of the platform. If the merchant refuses to provide the documents, materials or information required by the platform, Party B has the right to make a decision to disqualify the merchant according to the circumstances.',
  ptmz: 'Article 5: Platform Exemption',
  bcfx: 'The platform does not assume any responsibility for the following situations:',
  p38: '1. Your personal information is leaked because you have informed others of your account password or failed to keep your own password or shared your account with others or any other fault not caused by this website;',
  p39: '2. Any impact caused by hacker attacks, computer virus intrusions or outbreaks, technical adjustments of the telecommunications sector, temporary closures caused by government regulations, third-party reasons (including force majeure, such as international export trunk lines and international export telecommunications) Failure of the merchant, fire, flood, lightning strike, earthquake, flood, typhoon, tornado, volcanic eruption, plague and infectious disease epidemic, strike, war or violence or similar events, etc.) and other certifications not caused by the fault of this website Information leakage, loss, theft or tampering, etc.;',
  p40: '3. Leakage of bank account information caused by other websites linked to this website (such as online banking, etc.) and any legal disputes and consequences arising therefrom;',
  p41: '4. This website has nothing to do with any failure to pass certification or suffer any other losses caused by users providing wrong, incomplete, or false information to this website;',
  p42: '5. Your assets are defrauded by others due to reasons other than this platform.',
  ptts: 'Article 6: Platform Tips',
  p43: '1. In order to realize identity information review, this website may contain links to third-party websites (such as online banking websites) (hereinafter referred to as "linked websites"). "Linked sites" are not controlled by this website, and this site is not responsible for the content of any "linked sites", including but not limited to any links contained in "linked sites", or any changes or updates of "linked sites". This website is not responsible for the network communication or other forms of transmission received from the "linked website".',
  p44: '2. This platform only provides online trading platform services for you to conduct digital asset trading activities (including but not limited to digital asset trading and other services) through this website. This website does not participate in the act of buying and selling digital assets as a buyer or seller; this website It does not provide services related to the deposit and withdrawal of any national legal currency.',
  p45: '3. Once you log in to this website, use any service of this website or any other similar behavior, it means that you have understood and fully agreed to the contents of this agreement, including any modifications made by this website to this agreement at any time.',
  p46: '4. When you click on any button marked with "agree" or similar meanings during the use of this website, or actually use the services provided by this website in other ways permitted by this website, it means that you fully understand, agree and accept this agreement. Without your written signature, this agreement will have no effect on your legal binding force.',
  p47: '5. We reserve the right to amend this agreement from time to time and make announcements on the website without notifying you separately. The revised agreement will mark the time of the change on the homepage of this agreement, and once published on the website, it will automatically take effect immediately.',
  tyxy: 'I agree to the content of the agreement',
  nextStep: 'Next step'
}
const user = {
  txxz: 'Change the fund password and cannot withdraw cash for 24 hours',
  name: 'Nick name',
  rzdj: 'Identity Verification',
  phone: 'Phone',
  email: 'Email',
  zzc: 'Asset valuation',
  hours24: '24 hours',
  market: 'Market',
  notice: 'Announcement',
  more: 'More>>',
  cb: 'Deposit',
  tb: 'Withdraw coins',
  hz: 'Transfer',
  wsm: 'Unverified',
  cjrz: 'Primary certification',
  gjrz: 'Advanced Certification',
  qwgjrz: "Go to Advanced Verification",
  aqszx: 'Completed security settings',
  xgaqszx: 'Modify your security settings',
  dlmm: 'login password',
  zjdl: 'By setting a login password, you will be able to log in directly with your account number and login password',
  ghmm: 'change password',
  sz: 'set up',
  jymm: 'transaction password',
  yzjymm: 'When the account funds change, the transaction password needs to be verified first.',
  ghjymm: 'Change transaction password',
  sjyz: 'Phone verification',
  yzdx: 'Receive verification text messages when logging in, withdrawing cash, changing passwords, and security settings',
  xgsj: 'Modify mobile number',
  zwbd: 'Not yet bound',
  ggyz: 'google verification',
  syzn: "user's guidance",
  bd: 'to bind',
  yxyz: 'E-mail verification',
  tbqr: 'You can bind a common email address for login, password recovery, and confirmation when withdrawing coins',
  bdyx: 'Bind mailbox',
  xgyx: "Modify email address",
  xyx: "New mailbox",
  dljl: 'Last ten login records',
  zjdljl: 'Here are your last 10 login history',
  dlsj: 'last login time',
  ip: 'IP address',
  aqsz: 'Security Settings',
  yhdl: 'User login',
  xgbdsj: 'Modify the bound mobile phone',
  bdsj: 'bind phone',
  dxyzm: 'SMS verification code',
  second: 'Second',
  fsyzm: 'Send',
  xsjh: 'New mobile phone number',
  ggyzm: 'Google verification code',
  yxyzm: 'E-mail verification code',
  confirm: 'Sure',
  edit: 'Revise',
  name: 'Name',
  srxm: 'Please type in your name',
  zjlx: 'type of certificate',
  xzzjlx: 'Please select a document type',
  zjhm: 'ID number',
  srzjhm: 'Please enter the ID number',
  zcsr: 'please enter password again',
  mmbyz: 'The passwords entered twice are inconsistent!',
  sfz: 'ID card',
  jgz: 'Military ID',
  hz: 'passport',
  jmtxz: 'Taiwan Provincial Resident Pass',
  gatxz: 'Hong Kong and Macau Resident Pass',
  hwid: 'Overseas ID',
  srdx: 'Please enter SMS verification code',
  sryx: 'Please enter the email verification code',
  srgg: 'Please enter the Google verification code',
  jdlmm: 'old login password',
  xdlmm: 'New login password',
  qrxmm: 'Confirm the new password',
  qrdlmm: 'confirm login password',
  jjymm: 'old transaction password',
  xjymm: 'New transaction password',
  qrjymm: 'Confirm transaction password',
  qwcyz: 'Please complete verification',
  smrz: 'Please perform real-name authentication first',
  sryzm: 'please enter verification code',
  srsjh: 'Please enter phone number',
  xgdlmm: 'Change login password',
  szdlmm: 'Setting login password',
  xgjymm: 'Modify transaction password',
  szjymm: 'Set transaction password',
  czmm: 'reset Password',

  bdgg: 'Bind Google Authenticator',
  lbyzq: 'Please download Google 2-step authenticator',
  smewm: 'Scan the QR code with Google 2-Step Authenticator',
  srdm: 'If the QR code cannot be recognized, please manually enter the following code',
  copy: 'copy',
  copySuccess: 'Copy successfully',
  sryx: 'please input your email',
  srzqyx: 'Please input the correct email address',
  srsjyzm: 'Please enter the phone verification code',
  sryxyzm: 'Please enter the email verification code',
  srggyzm: 'Please enter the Google verification code',
  passwordTypeError: 'The password format is wrong. The password must be 8-32 characters, and contain both uppercase and lowercase letters and numbers.',
  passwordDiff: 'The two passwords do not match',
  zcsrxmm: 'please enter password again',
  language: 'language',
  bdhb: 'Currency',
  wdbph: 'Stablecoin preference',
  "相关问题": "Related Questions",
  "为什要进行身份认证": "Why undergo identity verification",
  "上传中": "Uploading...",
  "开始上传": "Start Upload",
  "请手持身份证正面": "Please hold the front of your ID card below your face",
  "正对摄像头": "Face the camera directly, maintain for at least 5 seconds",
  "摘下眼镜": "Remove glasses, hat, or other obstructions",
  "请按视频文字提示录制视频": "Record the video following the on-screen instructions",
  "开始录制": "Start Recording",
  "第一段视频": "First Video Segment",
  "第二段视频": "Second Video Segment",
  "录制一段视频": "Record a video segment",
  "点击开始录制": "Click to start recording",
  "视频录像认证": "Video Recording Verification",
  "身份证号": "ID Card Number",
  证件验证: "ID Verification (Photo/Scan)",
  zjyz: "ID Verification",
  "请确保图片格式为": "Please ensure the image format is jpg/jpeg/png. Ensure image size is less than 2MB",
  "请手持证件照": "Hold ID photo and personal signature. The signature should include 'Biking' and the current date",
  "当日签名照": "ID photo + signature with the current date",
  "上传证件签名页": "Upload ID card signature page",
  "请保证所有信息清晰": "Ensure all information is clear",
  "上传证件页信息": "Upload ID card information page",
  "请选择国家": "Select Country",
  "请选择区域": "Select Region",
  "认证要求": "Authentication Requirements",
  "证件信息": "ID Information",
  "人脸识别": "Facial Recognition",
  "立即认证": "Verify Now",
  "什么是加密货币P2P交易": "What is cryptocurrency P2P trading",
  "最好的P2P加密货币交易所是什么": "What is the best P2P cryptocurrency exchange",
  "P2P交易的成本有多少": "What is the cost of P2P trading",
  "什么是BikingP2P上的商家": "What are merchants on Biking P2P",
  "我们正在审核您的申请": "We are reviewing your application",
  "预计审核时间": "Estimated review time: 72 hours",
  "驳回": "Rejected",
  "未提交": "Not Submitted",
  "手续费等级": "Fee Levels",
  "去认证": "Go to Authentication",
  "开通更多权限": "Verify identity to unlock more privileges",
  "在别人贪婪时要保持警惕": "Be cautious when others are greedy, and be greedy when others are cautious",
  'kyc声明': 'I am {Name}, and my identification number is: {No}. I voluntarily register and transact on Biking, ensuring that the account is used by myself. I guarantee that all the assets are from legal sources, and I understand and can bear all transaction risks. The extracted digital assets will not be used for illegal purposes, and I will not engage in any illegal activities on this platform, such as money laundering, pyramid schemes, and illegal currency exchange.',
  "编辑头像": "Edit Avatar",
  "请选择一个头像用作您个人资料的照片": "Please select an avatar for your profile picture",
  "中国": "China",
  "其他": "Other",
  "1.为什么需要提供实名认证？": "1. Why is real-name authentication required?",
  "币王采用全球合规化身份验证服务，保障所有用户的资金安全。因此，在填写信息时，请务必提供符合要求的材料。": "Binance adopts globally compliant identity verification services to safeguard the funds of all users. Therefore, please be sure to provide the required materials when filling out information.",
  "2.完成身份认证有什么好处？": "2. What are the benefits of completing identity authentication?",
  "所有用户均须完成实名认证，方可访问币王的OTC功能。尚未完成实名认证的用户，不影响链上充值提现。": "All users must complete real-name authentication to access Binance's OTC functionality. Users who have not completed real-name authentication will not be affected by on-chain deposits and withdrawals.",
  "3. 如何更新身份认证？": "3. How to update identity authentication?",
  "若您的身份信息发生更改且符合以下条件时，您可以联系在线客服提交申请更新身份认证理由：": "If your identity information changes and meets the following conditions, you can contact customer service online to submit the reason for updating identity authentication:",
  "4. KYC认证需要多长时间？": "4. How long does KYC authentication take?",
  "您提交的信息通常会在5分钟内得到审核。 但是，如遇特殊情况可能需要更长的时间。": "The information you submit is usually reviewed within 5 minutes. However, in special circumstances, it may take longer.",
  "5. 币王身份认证安全吗？": "5. Is Binance identity authentication secure?",
  "Binance identity authentication is secure and helps us create a secure platform for you and all other users. Your documents are also confidential to us.": "Binance identity authentication is secure and helps us create a secure platform for you and all other users. Your documents are also confidential to us.",
  "1. 证件已过期；": "1. The document has expired;",
  "2. 证件上的姓名已更改；": "2. The name on the document has been changed;",
  "3. 证件上的身分证号码已变更；": "3. The ID number on the document has been changed;",
  "4. 国籍已变更；": "4. The nationality has been changed;",
  "5. 更新证件，以确保正常使用法币；": "5. Update documents to ensure normal use of fiat currency;",
  "6. 更改为系统语言识别的姓名（例如：从本国身份证改为护照）；": "6. Change the name recognized by the system language (for example: from a national ID card to a passport);",
  "系统错误": "System error",
  "验证中断": "Verification interrupted",
  "网络错误": "Network error",
  "客户端设备时间错误": "Client device time error",
  "认证失败": "Authentication failed",
  "人脸验证成功": "Face verification successful",
  "上传刷脸图片失败": "Failed to upload face picture",
  "数据错误或程序异常。": "Data error or program exception.",
  "网络错误。": "Network error.",
  "摄像头无权限或无法获取摄像头数据。": "No permission for camera or unable to obtain camera data.",
  "用户退出。": "User exited.",
  "重试次数过多。": "Too many retry attempts.",
  "视频上传超时。": "Video upload timed out.",
  "视频格式不满足要求。": "Video format does not meet requirements.",
  "视频中无有效人脸。": "No valid face in the video.",
  "验证不是同一个人。": "Verification is not the same person.",
  "法币充值": "Fiat Recharge & Withdrawal Limit",
  "无限额": "Unlimited",
  "数字货币充值": "Cryptocurrency Recharge",
  "数字货币提现限额": "Cryptocurrency Withdrawal Limit",
  "C2C交易限额": "C2C Trading Limit",
  "参数不合法": 'Invalid parameter',
  h5smrz: "Real-name authentication",
  bhzhan: "Set a password to protect your account security",
  jxsmrz: "Perform real-name authentication to ensure user funds security",
  qwrz: "Go to Verification",
  dgzhzd: "1. A single account can be submitted up to 5 times per day.",
  rhzp: "2. Any photos, videos, or document details you submit will not be stored or used in any way.",
  sfzm: "Proof of Identity",
  zjqfg: "Document Issuing Country",
  dw: "Positioning",
  sfxx: "Identity Information",
  dqdw: "Current Location",
  gjdq: "Country/Region"
}
const h5 = {
  chart: 'Chart',
  mmp: 'Order',
  sscj: 'Transaction',
  wt: 'entrust',
  lswt: 'historical commission',
  zj: 'funds',
  sj: 'Market price',
  ky: 'available',
  zczh: 'Asset conversion',
  dj: 'freeze',
  zwsj: 'No data',
  zx: 'optional',
  buysell: 'BUY/SELL'
}

const worldCup = {
  common: {
    cancel: 'Cancel',
    confirm: 'Confirm',
    iKnow: 'Got it',
    points: 'Points',
    day: 'd',
    hour: 'h',
    minute: 'm',
    second: 's',
    noData: 'No data',
    noMatch: 'No matches yet',
    businessClosed: 'Service is closed',
    loadFailed: 'Load failed, please try again later',
  },
  index: {
    liveFeed: 'Live Feed',
    heroTitle: 'World Cup Prediction',
    heroSplit: 'Share',
    heroPrizePool: 'Prize Pool',
    heroMillionPrizePool: 'Share Million Prize Pool',
    heroSub: 'Win Tesla and World Cup tickets',
    heroJoinedPrefix: 'Already',
    heroJoinedSuffix: 'participants, pool keeps growing',
    activityTimeLabel: 'Event Time: ',
    refreshing: 'Refreshing...',
    releaseToRefresh: 'Release to refresh',
    pullToRefresh: 'Pull to refresh',
    livePrizePool: 'Live Pool',
    growing: 'Growing',
    userPoolRatioLabel: 'Individual users share: ',
    teamPoolRatioLabel: 'Teams share: ',
    poolCountdownLabel: 'Countdown to split phase {phase} prize pool',
    poolCountdownFinalLabel: 'Countdown to final-stage pool split',
    poolActivityStartCountdownLabel: 'Until event starts',
    poolSplitDoneBadge: 'Distributed',
    totalAllocatedPoolLabel: 'Total distributed',
    poolAllocateFirst: '1st split',
    poolAllocateSecond: '2nd split',
    poolAllocateThird: '3rd split',
    poolAllocateFinal: 'Final split',
    poolTeamPrefix: 'Team: ',
    poolPersonalPrefix: 'Individual: ',
    poolPersonalCount: 'Individuals: {n}',
    teamTitle: 'Create Team, Boost Rewards',
    teamSubPrefix: 'Join a team to boost up to',
    teamSubSuffix: 'returns',
    teamAgentTitle: 'Platform Agent',
    teamAgentDesc: 'Platform agents can create teams with one click. <span class="wc-hl">Member points are aggregated into team points</span>, and team tasks grant <span class="wc-hl">extra bonus points</span>. Higher team points mean <span class="wc-hl">better chances to share the pool</span>.',
    createTeamNow: 'Create Team Now',
    applyAgentNow: 'Not an agent? Apply now',
    teamUserTitle: 'Regular User',
    teamUserDesc: 'No need to be an agent. Join a free team, team up with other users, and earn <span class="wc-hl2">chances to share the prize pool</span>.',
    joinNow: 'Join Now',
    championTitle: 'Champion Prediction',
    championSub: 'Each user can predict once only. After lock, it cannot be changed. Correct picks qualify for individual pool sharing.',
    championHintPrefix: 'Users who predict champion correctly can share',
    championHintSuffix: 'of the prize pool',
    championPoolShare: 'of the prize pool',
    championWin: 'Congrats! You predicted the champion',
    championLose: 'Sorry, your prediction missed',
    championWinSub: 'earned qualification for individual pool sharing',
    championNoParticipation: 'Event ended, you did not participate in the prediction',
    confirmPredict: 'Confirm Prediction',
    predictCountdown: 'Countdown',
    predictEnded: 'Prediction has ended',
    notice1: 'User p***12 completed prediction and won 500 points',
    notice2: 'User k***88 exchanged for a Tesla',
    notice3: 'User a***23 completed prediction and won 1200 points',
    notice4: 'User x***56 invited friends and got 100 points',
    notice5: 'User m***07 exchanged 1 World Cup ticket',
    tabPredict: 'Predict',
    tabTask: 'Task',
    tabRank: 'Rank',
    tabExchange: 'Exchange',
    tabMine: 'Mine',
    tabRules: 'Rules',
  },
  toast: {
    refreshSuccess: 'Refreshed successfully',
    predictSuccess: 'Prediction submitted successfully',
    inviteJumping: 'Redirecting to invite page...',
    applyAgentPending: 'Agent application feature is under development.',
    championLocked: 'Champion prediction locked!',
    exchangeSubmitted: 'Exchange request submitted successfully. Please wait for platform support to contact you.',
    pointsNotEnough: 'Insufficient points',
    createTeamSubmitted: 'Team created successfully',
    joinedFreeTeam: 'Joined free team',
  },
  section: {
    predictTitle: 'Match Prediction',
    predictSub: 'Predict the result, +{correctPoints} points if correct, +{wrongPoints} points if wrong',
    predictRules: 'Prediction Rules',
    taskTitle: 'Complete Tasks to Earn Points',
    taskSub: 'Multiple tasks and rewards to boost your progress',
    exchangeTitle: 'Points Exchange Mall',
    exchangeSub: 'Rich rewards, first come first served',
    exchangeRules: 'Exchange Rules',
    rankTitle: 'Live Rankings',
    rankSub: 'Compete and climb to the top',
    rulesTitle: 'Event Rules',
    rulesSub: 'Transparent, open and fair',
  },
  dialog: {
    taskTitle: 'Task Details',
    taskReward: 'Reward after completion',
    predictConfirmTitle: 'Match Prediction',
    predictConfirmHint: 'Which team do you think will win?',
    predictPay: 'Pay',
    predictPayTip: 'Deducted from capital account. Please ensure sufficient balance.',
    predictConfirmBtn: 'Confirm Prediction',
    predictSuccessTitle: 'Prediction Submitted',
    predictSuccessDesc: 'Prediction submitted successfully. Check records in "My Predictions".',
    exchangeTitle: 'Product Exchange',
    exchangeNeedPoints: 'Required Points',
    exchangeBalance: 'Balance:',
    exchangeContactTitle: 'Provide at least one contact method',
    exchangeTipTitle: 'Reminder',
    exchangeTip1: 'Please provide at least one contact. Support will contact you after submission.',
    exchangeTip2: 'If no one contacts you for a long time, please reach out to support proactively.',
    exchangeConfirm: 'Confirm Exchange',
    teamJoinTitle: 'Join Team',
    teamCreateDesc: 'Confirm creating a team?',
    teamJoinFreeDesc: 'Confirm joining the free team?',
    teamJoinTipTitle: 'Reminder',
    teamJoinTipDesc: 'You are already in an agent team and cannot join a free team. Invite your agent to form a team.',
    applyAgentContactTitle: 'Important Notice',
    applyAgentContactPrefix: 'Please add Telegram: ',
    applyAgentContactSuffix: ' to apply for an agent. After becoming an agent, you can then create a team.',
    applyAgentContactBtn: 'I See',
  },
  rank: {
    teamRank: 'Team Ranking',
    personRank: 'Personal Ranking',
    yourTeamRank: 'Your team rank',
    yourPersonRank: 'Your personal rank',
    captain: 'Captain: ',
    currentPoints: 'Current Points',
    members: 'Members',
    teamDetail: 'Team Details',
    noRankYet: 'No rankings yet',
  },
  mine: {
    myPoints: 'My Points',
    totalPoints: 'Total Points',
    myPredict: 'My Predictions',
    myExchange: 'My Exchanges',
    myBonus: 'My Bonus',
    totalBonus: 'Total bonus earned',
    bonusPhase: 'Distribution phase:',
    bonusPhaseFirst: 'Phase 1',
    bonusPhaseSecond: 'Phase 2',
    bonusPhaseThird: 'Phase 3',
    bonusPhaseFinal: 'Final phase',
    bonusTypeTeam: 'Team pool',
    bonusTypePersonal: 'Individual pool',
    bonusPoints: 'Points at distribution:',
    bonusType: 'Type:',
    bonusAmount: 'Bonus:',
    myTeam: 'My Team',
    selectTeam: 'Selected Team',
    predictMatch: 'Match',
    winTeam: 'Winning Team',
    predictResult: 'Result',
    hit: 'Hit',
    miss: 'Miss',
    draw: 'Draw',
    exchangeItem: 'Item',
    contactInfo: 'Contact',
    exchangeStatus: 'Status',
    currentRank: 'Current Rank',
    notJoinedTeam: 'Not joined a team',
    memberContribution: 'Member Contribution',
    teamTaskContribution: 'Team Task',
    loading: 'Loading...',
    statusDone: 'Completed',
    statusPending: 'Processing',
    statusFail: 'Exchange Failed',
    logCompleteKyc: 'KYC Completed',
    logExchangePrize: 'Prize Exchange',
    logMatchPredict: 'Match Prediction',
    logDailySign: 'Daily Check-in',
    logFinishTask: 'Complete Task',
    taskFirstRecharge: 'Complete first recharge >= {amount} USDT',
    pagerTotal: 'Total {total} items',
    prevPage: 'Previous Page',
    nextPage: 'Next Page',
    goTo: 'Go to',
    page: 'page',
  },
  mobile: {
    title: 'World Cup Prediction',
  },
  nav: {
    entry: 'World Cup Prediction',
  },
  mock: {
    korea: 'Korea',
    germany: 'Germany',
    china: 'China',
    uk: 'UK',
    france: 'France',
    portugal: 'Portugal',
    senegal: 'Senegal',
    brazil: 'Brazil',
    india: 'India',
    turkiye: 'Turkiye',
    usa: 'USA',
    jerseyPack: 'Official Jersey Pack',
    vipCard: 'VIP Crypto Membership Card',
    jerseyKeyword: 'Jersey',
  },
  predict: {
    round: {
      group: 'Group Stage',
      r32: 'Round of 32',
      r16: 'Round of 16',
      quarter: 'Quarterfinal',
      semi: 'Semifinal',
      third: 'Third-place',
      final: 'Final',
    },
    status: {
      joined: 'Joined',
      open: 'Open',
      ongoing: 'In Progress',
      ended: 'Ended',
    },
    btn: {
      joined: 'Predicted',
      open: '{betPaymentAmount}USDT Predict Now',
      ongoing: 'In Progress',
      ended: 'Prediction Closed',
    },
    joinedMatchPhase: {
      pending: 'Not started',
      ongoing: 'In progress',
      ended: 'Finished',
    },
    joinedResult: {
      hit: 'Correct +{points}',
      missPrefix: 'Wrong',
      missSuffix: '+{points}',
    },
  },
  rules: {
    fundSource: 'Fund Source',
    poolSplit: 'Prize Pool Split',
    teamIntro: 'Team Introduction',
    poolRulesTitle: 'Pool Rules',
    teamRulesTitle: 'Team Rules',
    predictRulesTitle: 'Prediction Rules',
    exchangeRulesTitle: 'Exchange Rules',
  },
  rulesText: {
    poolDesc1: 'Initial prize pool is {initialFunds} USDT. During the event period, part of business revenue is injected into the pool to keep increasing it.',
    poolLine1: '{rechargePercentageToPool}% of each deposit is added to the prize pool;',
    poolLine2: '{contractFeePercentageToPool}% of each perpetual futures trading fee is added to the prize pool;',
    poolLine3: 'For every valid invited user, the prize pool increases by {additionalAmountPerValidUser} USDT.',
    poolLine4: '*Amounts below 0.01 USDT will not be counted toward the prize pool.',
    teamPoolTitle: 'Team Prize Pool',
    teamPoolRuleTitle: 'Team Prize Pool Rules',
    teamPoolRule1: 'After a team wins a pool split, the captain (except free teams) receives 20% of the split reward. Captain reward = total pool * split ratio * 20%',
    teamPoolRule2: 'Eligible team members receive rewards based on their personal points contribution. Member reward = [(total pool * team split ratio) * (1 - 0.2) / sum of eligible members points] * personal total points',
    userPoolTitle: 'Individual Prize Pool Rules',
    poolSplit1: 'First split: after the top 8 teams are confirmed, the No.1 team shares {percentage}% of the pool and the remainder keeps accumulating',
    poolSplit2: 'Second split: after the top 4 teams are confirmed, the No.1 team shares {percentage}% of the pool and the remainder keeps accumulating',
    poolSplit3: 'Third split: after the semifinals end, the No.1 team shares {percentage}% of the pool and the remainder keeps accumulating',
    poolSplit4: 'Final split: after the final ends, the No.1 team shares {percentage}% of the entire pool. After the split is completed, available points of team members will be reset to zero',
    userPoolLine1: 'After matches end, users who predicted champion correctly are eligible for individual pool sharing',
    userPoolLine2: 'All users who predicted champion correctly share {percentage}% of the pool by total points. After the split is completed, available personal points will be reset to zero.',
    poolFormula: '*Example: assume a team has N qualified users, each user\'s points are N1, N2, N3...Nn, the pool amount at settlement is A, the split ratio is 20%, and captain reward ratio is 20%, then team member reward = [(A*20%)(1-0.2)/(N1+N2+N3+...+Nn)]*personal total points',
    teamRule1: '1. Only level-1 agents can create teams; non-agents need to apply first',
    teamRule2: '2. Users who are not agents and cannot become agents can join a platform free team',
    teamRule3: '3. After an agent creates a team, their members join the same team automatically',
    teamRule4: '4. Team points = member points sum + team task bonus points',
    teamRule5: '5. Team member eligibility for prize pool: at least {quizTimesThreshold} predictions + perpetual futures volume ≥ {poolContractThreshold}U',
    predictRule1: '1. Predictions close once the match starts',
    predictRule2: '2. Each user can predict each match only once',
    predictRule3: '3. Prediction requires paying {betPaymentAmount} USDT',
    predictRule4: '4. Correct prediction: +{correctBonusPoints} points, wrong prediction: +{wrongBonusPoints} point',
    predictRule5: '5. If group match ends in draw, it is counted as wrong prediction, +{wrongBonusPoints} point',
    exchangeRule1: '1. Prize quantity is limited, first come first served',
    exchangeRule2: '2. Exchanging prizes deducts corresponding personal and team points',
    exchangeRule3: '3. Fill contact info when exchanging; support will contact for prize delivery',
    exchangeRule4: '4. Wrong contact info may block delivery, please verify and keep watching messages',
    exchangeRule5: '5. If not contacted for long time, please contact support proactively',
    timeTitle: 'Event Time',
    activePeriodLabel: 'Event duration: ',
    activePeriodValue: '{startTime} ~ {endTime}',
    activeTip: 'Points are counted and tracked only after the event starts, and the prize pool begins to accumulate.',
    predictPeriodLabel: 'Prediction window: ',
    predictPeriodValue: 'Champion prediction: {startTime} ~ {endTime}',
    businessTitle: 'Business Rules',
    businessRule1: '1. Valid invited user: invitee deposit ≥{inviteRechargeThreshold}U and perpetual futures volume ≥{contractVolumeThreshold}U',
    businessRule2: '2. Team members eligible for prize pool split: at least {quizTimesThreshold} predictions + perpetual futures volume ≥{poolContractThreshold}U during event',
    businessRule3: '3. Personal points can be used to exchange gifts anytime; corresponding personal/team points are deducted after exchange',
    businessRule4: '4. Physical prizes are limited and available while supplies last',
    businessRule5: '5. World Cup ticket exchange closes one day before opening; if force majeure prevents ticket redemption, equivalent USDT will be provided',
    statementTitle: 'Important Statement',
    statement1: '1. Each user may participate with only one account. Multiple accounts (including batch registration or related accounts) are prohibited. The platform monitors devices and IPs, and may classify accounts using the same device/IP as related accounts;',
    statement2: '2. Trading behavior in the event must be authentic and valid. Wash trading, matched trading, or self-trading are strictly prohibited',
    statement3: '3. The risk control system identifies abnormal trading behaviors, including but not limited to high-frequency reverse open/close, same-price hedging, and low-risk volume brushing arbitrage',
    statement4: '4. Once abnormal trading is detected, the platform may remove points generated from such trades, disqualify participation, and freeze/reclaim related rewards',
    statement5: '5. Prize pool amount and reward allocation are subject to the platform final statistics, and the platform reserves final interpretation rights',
  },
  exchange: {
    needPoints: 'Required Points',
    stock: 'Stock',
    buyNow: 'Exchange Now',
    soldOut: 'Sold Out',
    badgeUnique: 'Unique Grand Prize',
    badgeOnlyCount: 'Only {count}',
    itemFinalTicket: 'World Cup Final Ticket',
    itemSignedFootball: 'Signed Football',
  },
  task: {
    earnPoints: 'Earn Points',
    goFinish: 'Go',
    goTeamTask: 'Do tasks to earn team points',
  },
  taskGroup: {
    daily: 'Daily Tasks',
    invite: 'Invite Tasks',
    recharge: 'Recharge Tasks',
    teamTrade: 'Team Trading Tasks',
    dailyLimitPrefix: 'Daily reward cap',
    teamLimitPrefix: 'Team daily reward cap',
    limitPoints: '{num} points',
    limitSuffix: ', refreshed daily at 00:00:00 (GMT+08:00)',
    rechargeLimitSuffix: 'Only first recharge during event period counts',
    inviteCta: 'Invite Now to Earn Points',
    taskPredictOnce: 'Participate in one match prediction',
    taskTrade10000: 'Each accumulated perpetual futures volume {tradeVolume}U',
    taskInviteValidUser: 'Complete one valid user invite',
    taskInviteRegister: 'Invite friend to register',
    taskInviteKyc: 'Invite friend to complete KYC',
    taskInviteRecharge: 'Invite friend to complete first recharge',
    taskFirstRecharge: 'First recharge >= {amount} USDT',
    taskTeamTrade10000: 'Each accumulated {tradeVolume} USDT perpetual futures trading volume, team +{teamBonusPoints} points',
  },
};

export {
  apis,
  games,
  h5,
  trading,
  download,
  login,
  user,
  advertise,
  otcMerchant,
  otc,
  menu,
  time,
  state,
  text,
  seckillRes,
  header,
  hyy,
  Verification,
  index,
  NAVS,
  FOOTERS,
  SIDEBAR,
  seckill,
  apply,
  recommend,
  market,
  banner,
  card,
  news,
  info,
  navCard,
  choice,
  plat,
  risk,
  license,
  footer,
  merchandiser,
  codeInfo,
  placeOrder,
  tableList,
  codelist,
  contractHyy,
  common,
  dialog,
  panKou,
  invite,
  property,
  contest,
  taskCenter,
  ieo,
  earn,
  tradingContest,
  agent,
  live,
  hongbao,
  worldCup
};



// WEBPACK FOOTER //
// ./src/i18n/lang/public/en.js